"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const visibilitySensor_1 = require("./visibilitySensor");
const expoHooks = [];
exports.expoSensor = new visibilitySensor_1.default({
    checkVisiable(container, rect, el) {
        const width = rect.right - rect.left;
        const height = rect.bottom - rect.top;
        if (width == 0 && height == 0) {
            return false;
        }
        return width >= 0 &&
            height >= 0 &&
            container.bottom >= rect.top + 0.5 * height &&
            container.top <= rect.bottom - 0.5 * height &&
            container.right >= rect.left &&
            container.left <= rect.right;
    },
    getCheckElements() {
        return expoHooks.map((item) => item.el);
    },
    onChange(isVisible, el) {
        if (isVisible) {
            expoHooks.forEach((item, index) => {
                if (item.el === el) {
                    item.onExpo();
                    expoHooks.splice(index, 1);
                }
            });
        }
    },
});
exports.expoSensor.watch();
exports.default = {
    addHook(hook) {
        expoHooks.push(hook);
    },
    addWatchScroll(el) {
        exports.expoSensor.addWatchElementScroll(el);
    },
    deleteHook(target) {
        const index = expoHooks.findIndex(it => it === target);
        if (index > -1) {
            expoHooks.splice(index, 1);
        }
    },
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXhwb1NlbnNvci5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImV4cG9TZW5zb3IudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSx5REFBa0Q7QUFFbEQsTUFBTSxTQUFTLEdBQWdCLEVBQUUsQ0FBQztBQUVyQixRQUFBLFVBQVUsR0FBRyxJQUFJLDBCQUFnQixDQUFDO0lBQzNDLGFBQWEsQ0FBQyxTQUFTLEVBQUUsSUFBSSxFQUFFLEVBQUU7UUFDN0IsTUFBTSxLQUFLLEdBQUcsSUFBSSxDQUFDLEtBQUssR0FBRyxJQUFJLENBQUMsSUFBSSxDQUFDO1FBQ3JDLE1BQU0sTUFBTSxHQUFHLElBQUksQ0FBQyxNQUFNLEdBQUcsSUFBSSxDQUFDLEdBQUcsQ0FBQztRQUN0QyxJQUFHLEtBQUssSUFBSSxDQUFDLElBQUksTUFBTSxJQUFJLENBQUMsRUFBQztZQUN6QixPQUFPLEtBQUssQ0FBQTtTQUNmO1FBRUQsT0FBTyxLQUFLLElBQUksQ0FBQztZQUNiLE1BQU0sSUFBSSxDQUFDO1lBQ1gsU0FBUyxDQUFDLE1BQU0sSUFBSSxJQUFJLENBQUMsR0FBRyxHQUFHLEdBQUcsR0FBRyxNQUFNO1lBQzNDLFNBQVMsQ0FBQyxHQUFHLElBQUksSUFBSSxDQUFDLE1BQU0sR0FBRyxHQUFHLEdBQUcsTUFBTTtZQUMzQyxTQUFTLENBQUMsS0FBSyxJQUFJLElBQUksQ0FBQyxJQUFJO1lBQzVCLFNBQVMsQ0FBQyxJQUFJLElBQUksSUFBSSxDQUFDLEtBQUssQ0FBQztJQUNyQyxDQUFDO0lBQ0QsZ0JBQWdCO1FBQ1osT0FBTyxTQUFTLENBQUMsR0FBRyxDQUFDLENBQUMsSUFBSSxFQUFFLEVBQUUsQ0FBQyxJQUFJLENBQUMsRUFBRSxDQUFDLENBQUM7SUFDNUMsQ0FBQztJQUNELFFBQVEsQ0FBQyxTQUFrQixFQUFFLEVBQVc7UUFDcEMsSUFBSSxTQUFTLEVBQUU7WUFDWCxTQUFTLENBQUMsT0FBTyxDQUFDLENBQUMsSUFBSSxFQUFFLEtBQUssRUFBRSxFQUFFO2dCQUM5QixJQUFJLElBQUksQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFO29CQUNoQixJQUFJLENBQUMsTUFBTSxFQUFFLENBQUM7b0JBQ2QsU0FBUyxDQUFDLE1BQU0sQ0FBQyxLQUFLLEVBQUUsQ0FBQyxDQUFDLENBQUM7aUJBQzlCO1lBQ0wsQ0FBQyxDQUFDLENBQUM7U0FDTjtJQUNMLENBQUM7Q0FDSixDQUFDLENBQUM7QUFFSCxrQkFBVSxDQUFDLEtBQUssRUFBRSxDQUFDO0FBT25CLGtCQUFlO0lBQ1gsT0FBTyxDQUFDLElBQWU7UUFDbkIsU0FBUyxDQUFDLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQztJQUN6QixDQUFDO0lBRUQsY0FBYyxDQUFDLEVBQUU7UUFDYixrQkFBVSxDQUFDLHFCQUFxQixDQUFDLEVBQUUsQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFFRCxVQUFVLENBQUMsTUFBaUI7UUFDeEIsTUFBTSxLQUFLLEdBQUcsU0FBUyxDQUFDLFNBQVMsQ0FBQyxFQUFFLENBQUMsRUFBRSxDQUFDLEVBQUUsS0FBSyxNQUFNLENBQUMsQ0FBQztRQUN2RCxJQUFJLEtBQUssR0FBRyxDQUFDLENBQUMsRUFBRTtZQUNaLFNBQVMsQ0FBQyxNQUFNLENBQUMsS0FBSyxFQUFFLENBQUMsQ0FBQyxDQUFDO1NBQzlCO0lBQ0wsQ0FBQztDQUNKLENBQUMifQ==